"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _SupportedPlaceholders = _interopRequireDefault(require("../../hike/components/SupportedPlaceholders.vue"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoopEmailSetting',
  components: {
    Tinymce: _Tinymce.default,
    SupportedPlaceholders: _SupportedPlaceholders.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    parentAutomatedEmail: {
      type: Array,
      default: []
    },
    parentEmailRuleSet: {
      type: String,
      default: _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_GENERAL_HIKE
    }
  },
  data: function data() {
    return {
      loading: false,
      haveLoop: false,
      emailSetting: []
    };
  },
  watch: {
    emailSetting: {
      handler: function handler(newVal) {
        var newEmailSetting = newVal.map(function (p) {
          if (p.remarks === "") {
            return {
              ruleName: p.name,
              subject: p.defaultSubject,
              content: p.defaultContent
            };
          }
        }).filter(function (p) {
          return p !== undefined;
        });
        console.info('newEmailSetting');
        console.info(newEmailSetting);
        this.passBackToParent(newEmailSetting);
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.emailRuleSet = _this.parentEmailRuleSet;
            // this.emailSetting = this.parentAutomatedEmail;
            _this.initEmailSetting();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    initEmailSetting: function initEmailSetting() {
      this.emailSetting = [];
      var item = _lhJsEmailContentLib.ruleNames.SCHEDULED_EMAIL_RULE_LOOP_ENROLLMENT;
      var emailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(item);
      var parentEmailSetting = this.parentAutomatedEmail.find(function (p) {
        return p.ruleName === item;
      });
      if (parentEmailSetting !== null && parentEmailSetting !== undefined) {
        emailSetting.defaultSubject = parentEmailSetting.subject;
        emailSetting.defaultContent = parentEmailSetting.content;
      }
      emailSetting.name = item;
      emailSetting.showPlaceholders = false;
      var remarks = '';
      // if (this.haveLoop) {
      // 	if (!emailSetting.enableWhenHikeInLoop) {
      // 		remarks = "It will not trigger because the Hike is within a Loop.";
      // 	}
      // } else {
      // 	if (!emailSetting.enableWhenHikeNotInLoop) {
      // 		remarks = "It will not trigger because the Hike is not within a Loop.";
      // 	}
      // }
      emailSetting.remarks = remarks;
      console.log(emailSetting);
      this.emailSetting.push(emailSetting);
    },
    ruleSettingChange: function ruleSettingChange() {
      this.initEmailSetting();
    },
    resetSubjectContent: function resetSubjectContent(name, index) {
      var defaultEmailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(name);
      var currentSetting = this.emailSetting[index];
      currentSetting.defaultSubject = defaultEmailSetting.defaultSubject;
      currentSetting.defaultContent = defaultEmailSetting.defaultContent;
      //this.$set(this.emailSetting, index, currentSetting)
      //Fixed the tinymce editor reset update ui bug
      this.$nextTick(function () {
        return window.tinymce.get('descriptionEditor' + index).setContent(currentSetting.defaultContent || '');
      });
    },
    switchPlaceholders: function switchPlaceholders(showPlaceholders, index) {
      var currentSetting = this.emailSetting[index];
      currentSetting.showPlaceholders = showPlaceholders;
    },
    passBackToParent: function passBackToParent(res) {
      this.$emit("updateParentEmailRuleSet", res);
    }
  }
};